import { ClipspecWorkflow } from './clipspec-api/ClipspecIntegrationAPI'
import ButtonsPopup from '../components/ButtonsPopup'
import React from 'react'
import { BuildConfig } from '../config/BuildConfig'
import { WarningPopupGraphic } from '../components/WarningPopupGraphic'

export interface ClipspecHandoffImageErrorProps {
  onBack: () => void
  onContinue: () => void
  numErrors: number
  workflow: ClipspecWorkflow
}

export function ClipspecHandoffImageErrorPopup({
  onBack,
  onContinue,
  numErrors,
  workflow,
}: ClipspecHandoffImageErrorProps) {
  const { ImageErrorPopup: copy } = BuildConfig.brand.copy.Clipspec

  return (
    <ButtonsPopup
      orientation="row"
      actions={[{
        label: copy.BackButton,
        style: 'default',
        onClick: onBack,
      }, {
        label: copy.ContinueButton,
        style: 'green',
        onClick: onContinue,
      }]}
    >
      <WarningPopupGraphic />
      <div className="title">
        {copy.Title(numErrors)}
      </div>
      <div style={{ textAlign: 'center' }}>
        {workflow === ClipspecWorkflow.Consultation
          ? copy.Body_ConsultationFlow
          : copy.Body_ProductFlow
        }
      </div>
    </ButtonsPopup>
  )
}